import { Box, Skeleton, Text } from '@newday/core';
import { useApplicationId } from '../../app';
import {
  ContentWrapper,
  HeaderStepper,
  Hero,
  ReferStepper,
  ResponsivePageLayout,
} from '../../components';
import { useApplicationReference, useUserDetails } from '../../shared/queries';

export const BankDetailsReferPage: React.FC = () => {
  const { applicationId } = useApplicationId();
  const { data, isSuccess: isSuccessAppRef } =
    useApplicationReference(applicationId);
  const { data: userDetails, isSuccess: isSuccessUserDetails } = useUserDetails(
    applicationId,
    { obfuscateEmail: true }
  );

  return (
    <ResponsivePageLayout headerStepper={<HeaderStepper activeStep={4} />}>
      <Hero
        title="Nearly there - but we need to check your bank details"
        subtitle="We're having trouble verifying the bank details you gave us. To make sure your loan reaches your account safely, we'll need to look into this."
        variant="dark"
      >
        <Skeleton isLoaded={isSuccessAppRef} mt={4}>
          <Text color="white" fontWeight="semibold">
            {`Your application reference is ${data?.reference}.`}
          </Text>
        </Skeleton>
      </Hero>
      <ContentWrapper py={8}>
        <Text
          as="legend"
          mb={2}
          fontSize="lg"
          color="brand.primary"
          fontWeight="bold"
        >
          What happens next?
        </Text>
        <ReferStepper skipDocumentUploadedStep activeStep={1} py={3} />
        <Box>
          We&apos;ll investigate the issue with your bank. This usually takes
          about&nbsp;
          <Text fontWeight="bold" display="inline">
            three working days
          </Text>
          , but we&apos;ll be as quick as we can.
        </Box>
        <Skeleton isLoaded={isSuccessUserDetails} mt={4}>
          <Box>
            When we know more, we&apos;ll update you by email at&nbsp;
            <Text display="inline" textDecoration="underline">
              {userDetails?.emailAddress}
            </Text>
            . If we&apos;ve been able to verify your bank details, you should
            receive your loan within 48 hours.
          </Box>
        </Skeleton>
      </ContentWrapper>
    </ResponsivePageLayout>
  );
};
